import { useEffect, useRef } from 'react'
import { useNavigate, useSearch } from '@tanstack/react-router'
import clsx from 'clsx'
import { v4 as uuidv4 } from 'uuid'

import { sberBindCard, sberBindCardStatus } from '@/shared/api'
import { useAppNavbar } from '@/shared/hooks/use-app-navbar'

import styles from './pass-card-bind.module.scss'

export const PassCardBind = () => {
    useAppNavbar(' ', null, null)
    const navigate = useNavigate()
    const { tx } = useSearch({ from: '/_protected/pass-card-bind/' })

    const isFetchingRef = useRef(false)
    const isCheckingStatus = tx !== undefined

    useEffect(() => {
        if (isFetchingRef.current || tx !== undefined) {
            return
        }

        const fetchData = async () => {
            await sberBindCard({
                job_id: uuidv4(),
            })
                .then((res) => {
                    if (res.response.merchant_url) {
                        globalThis.location.href = res.response.merchant_url
                    }
                })
                .catch((error) => {
                    navigate({
                        to: '/pass-card-bind/error',
                        search: { error: error.error ?? 'error' },
                    })
                })
        }

        isFetchingRef.current = true
        fetchData()
    }, [tx, navigate])

    useEffect(() => {
        if (isFetchingRef.current === false && tx !== undefined) {
            isFetchingRef.current = true
            sberBindCardStatus({ txn_id: Number(tx) })
                .then((res) => {
                    if (res.status === '3') {
                        navigate({
                            to: '/pass-card-bind/success',
                            search: { cardPanLast4: res.last4 },
                        })
                    } else {
                        navigate({
                            to: '/pass-card-bind/error',
                            search: { error: `status: ${res.status}` },
                        })
                    }
                })
                .catch((error) => {
                    navigate({
                        to: '/pass-card-bind/error',
                        search: { error: error.error ?? 'error' },
                    })
                })
        }
    }, [tx, navigate])

    if (isCheckingStatus) {
        return (
            <div className={styles['pass-card-bind']}>
                <div className={clsx(styles['pass-card-bind__loader'], 'loader')} />
            </div>
        )
    }

    return (
        <div className={styles['pass-card-bind']}>
            <div className={clsx(styles['pass-card-bind__loader'], 'loader')} />
            <span className={styles['pass-card-bind__title']}>Проверяем вашу карту</span>
        </div>
    )
}
